import React from 'react';
import TableauDeBord from './TableauDeBord';
import menuDatas from './MenuDatas';

export default function activePage() {
    var retour = {
        instance:null,
        page:null,
        showBottomNavigation: false,
        visiblePath: ""
    }
    var currPath = window.location.pathname;
    if (currPath.length > 1) {
        currPath = currPath.replace(/\/$/, "");
    }
    retour.page = <TableauDeBord />;
    Object.keys(menuDatas).forEach(menu => {
        var path = menuDatas[menu].path.replace(/^[.]+/, '');
        if(path === currPath || (menuDatas[menu].exact === false && currPath.includes(path))){
            retour.page = menuDatas[menu].component;
            retour.showBottomNavigation = menuDatas[menu].showBottomNavigation;
            retour.instance = menuDatas[menu].instance;
            retour.path = path;
            if(menuDatas[menu].pathvar != null){
                retour.path += menuDatas[menu].pathvar;
            }
            retour.visiblePath = currPath;
            retour.exact = menuDatas[menu].exact;
            return retour;
        }
    });
    return retour;
}


// WEBPACK FOOTER //
// ./src/components/content/manageContent.js